<template>
  <div class="page">
    <div class="item-title">总账</div>
    <div class="item-line"></div>

    <div class="item-main">
      <el-card class="box-card">
        <div slot="header">
          <span>应收金额（元）</span>
        </div>
        <countTo
          class="text item"
          :startVal="0"
          :endVal="countall.totalAmount / 100"
          :duration="1000"
          :decimals="2"
          prefix="¥ "
        ></countTo>
      </el-card>
      <el-card class="box-card">
        <div slot="header">
          <span>实收金额（元）</span>
        </div>
        <countTo
          class="text item"
          :startVal="0"
          :endVal="countall.paidAmount / 100"
          :duration="1000"
          :decimals="2"
          prefix="¥ "
        ></countTo>
      </el-card>
      <el-card class="box-card">
        <div slot="header">
          <span>欠款金额（元）</span>
        </div>
        <countTo
          class="text item"
          :startVal="0"
          :endVal="countall.unpaidAmount / 100"
          :duration="1000"
          :decimals="2"
          prefix="¥ "
        ></countTo>
      </el-card>
      <el-card class="box-card">
        <div slot="header">
          <span>预存金额（元）</span>
        </div>
        <countTo
          class="text item"
          :startVal="0"
          :endVal="countall.balanceAmount / 100"
          :duration="1000"
          :decimals="2"
          prefix="¥ "
        ></countTo>
      </el-card>
    </div>

    <div class="item-title">项目汇算</div>
    <div class="item-line"></div>

    <div style="margin-top: 30px">
      <div class="div-2-top item-main-plus ">
        <div class="item-main-plus">
          <span>账单时间：</span>
          <el-date-picker
            :clearable="false"
            style="width: 230px"
            v-model="daterange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div style="margin-left: 30px" class="item-main-plus">
          <span>支付时间：</span>
          <el-date-picker
            :clearable="false"
            style="width: 230px"
            v-model="daterangePaid"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div style="margin-left: 30px" class="item-main-plus">
          <span>项目：</span>
          <el-checkbox-group v-model="pricingTypes">
            <el-checkbox label="分期"></el-checkbox>
            <el-checkbox label="一次性"></el-checkbox>
            <el-checkbox label="按量"></el-checkbox>
          </el-checkbox-group>
        </div>
        <el-button
          style="margin-left: 80px; width: 100px"
          type="primary"
          @click="getSettle"
          >汇 算</el-button
        >
      </div>

      <div style="margin-top: 30px">
        <div class="div-2-top item-main-plus ">
          <div class="item-main-plus">
            <span>区域：</span>
            <el-cascader
              :props="areaProps"
              v-model="areaIDSelect"
            ></el-cascader>
          </div>
          <div style="margin-left: 30px" class="item-main-plus">
            <span>房号：</span>
            <el-input
              style="width: 180px"
              placeholder="请输入房号"
              v-model="houseNameRegex"
              clearable
            ></el-input>
          </div>
        </div>
      </div>

      <div class="item-main">
        <el-card class="box-card">
          <div slot="header">
            <span>应收金额（元）</span>
          </div>
          <countTo
            class="text item"
            :startVal="0"
            :endVal="settle.totalAmount / 100"
            :duration="1000"
            :decimals="2"
            prefix="¥ "
          ></countTo>
        </el-card>
        <el-card class="box-card">
          <div slot="header">
            <span>实收金额（元）</span>
          </div>
          <countTo
            class="text item"
            :startVal="0"
            :endVal="settle.paidAmount / 100"
            :duration="1000"
            :decimals="2"
            prefix="¥ "
          ></countTo>
        </el-card>
        <el-card class="box-card">
          <div slot="header">
            <span>欠款金额（元）</span>
          </div>
          <countTo
            class="text item"
            :startVal="0"
            :endVal="settle.unpaidAmount / 100"
            :duration="1000"
            :decimals="2"
            prefix="¥ "
          ></countTo>
        </el-card>
      </div>

      <el-table :data="pricings">
        <el-table-column prop="type" label="项目类型" align="center">
        </el-table-column>
        <el-table-column prop="name" label="项目名称" align="center">
        </el-table-column>
        <el-table-column label="应收金额(元)" align="center">
          <template slot-scope="scope">
            <span>{{ numFormat(scope.row.totalAmount / 100) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实收金额(元)" align="center">
          <template slot-scope="scope">
            <span
              style="color: #409eff"
              @click="showDialog(scope.row.name, '已支付')"
              >{{ numFormat(scope.row.paidAmount / 100) }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="欠款金额(元)" align="center">
          <template slot-scope="scope">
            <span
              style="color: #409eff"
              @click="showDialog(scope.row.name, '未支付')"
              >{{ numFormat(scope.row.unpaidAmount / 100) }}</span
            >
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :visible.sync="dialogVisible" title="缴费信息" width="70%">
        <el-table :data="listData">
          <el-table-column prop="houseName" label="房号" align="center">
          </el-table-column>
          <el-table-column prop="areaName" label="所属区域" align="center">
          </el-table-column>
          <el-table-column prop="pricingName" label="收费项目" align="center">
          </el-table-column>
          <el-table-column prop="billStart" label="开始时间" align="center">
          </el-table-column>
          <el-table-column prop="billEnd" label="结束时间" align="center">
          </el-table-column>
          <el-table-column prop="leaseState" label="合同状态" align="center">
          </el-table-column>
          <el-table-column
            prop="totalAmountStr"
            label="应收金额(元)"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="paidAmountStr"
            label="实收金额(元)"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="payState" label="支付状态" align="center">
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Utils from "../../Utils";
import moment from "moment";
import { Loading } from "element-ui";

import mixins from "../../minix";

import countTo from "vue-count-to";

let _vue;

export default {
  name: "Count",

  components: { countTo },

  mixins: [mixins],

  data() {
    return {
      countall: {
        totalAmount: "",
        paidAmount: "",
        unpaidAmount: "",
        balanceAmount: ""
      },
      settle: {
        totalAmount: "",
        paidAmount: "",
        unpaidAmount: ""
      },
      daterange: "",
      daterangePaid: "",
      listData: [],
      pricings: [],
      dialogVisible: false,
      houseNameRegex: "",
      areaIDSelect: ["全部区域"],
      pricingTypes: ["分期", "一次性", "按量"],
      areaProps: {
        checkStrictly: true,
        lazy: true,
        async lazyLoad(node, resolve) {
          let superAreaID = "";
          if (node.level > 0) {
            superAreaID = node.data.value;
          }
          let list = await _vue.areasQuery(superAreaID);
          let resolveData = [];
          if (list) {
            list.forEach(item => {
              resolveData.push({
                value: item.id,
                label: item.name
              });
            });
          }
          if (node.level === 0) {
            resolveData.unshift({
              value: "全部区域",
              label: "全部区域"
            });
          }
          resolve(resolveData);
        }
      }
    };
  },

  created() {
    _vue = this;

    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", "Web_Admin");

    this.daterange = [moment().startOf("month"), moment().endOf("month")];
    this.daterangePaid = [moment().startOf("month"), moment().endOf("month")];
    this.getCountAll();
    this.getSettle();
  },

  methods: {
    async areasQuery(superAreaID) {
      let returnData = [];
      await axios({
        method: "post",
        url: "areas/query",
        data: {
          pageIdx: 0,
          pageSize: 100,
          superAreaID: superAreaID
        }
      })
        .then(value => {
          returnData = value.data.data;
        })
        .catch(() => {});
      return returnData;
    },

    async showDialog(pricingName, state) {
      const loading = Loading.service({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      let data = {
        houseNameRegex: this.houseNameRegex,
        state: state,
        pricingName: pricingName,
        pageSize: 100,
        pageIdx: 0,
        start: parseInt(new Date(this.daterange[0]).getTime() / 1000),
        paidStart: parseInt(new Date(this.daterangePaid[0]).getTime() / 1000),
        paidEnd: parseInt(new Date(this.daterangePaid[1]).getTime() / 1000),
        end: parseInt(new Date(this.daterange[1]).getTime() / 1000)
      };

      if (this.areaIDSelect.length > 0) {
        data.areaID = this.areaIDSelect[this.areaIDSelect.length - 1];
      }

      await axios({
        method: "post",
        url: "bills/query",
        data: data
      })
        .then(value => {
          this.listData = [];
          if (value && value.data && value.data.data) {
            value.data.data.forEach(item => {
              item.billStart = Utils.long2day(item.billStart * 1000);
              item.billEnd = Utils.long2day(item.billEnd * 1000);
              item.paidTime = Utils.long2day(item.paidTime * 1000);
              item.paidAmountStr = item.paidAmount / 100;
              item.totalAmountStr = item.totalAmount / 100;
              this.listData.push(item);
            });
          }
        })
        .catch(() => {});

      loading.close();

      this.dialogVisible = true;
    },

    getCountAll() {
      let baseURL = axios.defaults.baseURL.replace("/org", "");

      axios({
        method: "post",
        url: `${baseURL}countall`
      })
        .then(value => {
          this.countall = value.data.data;
        })
        .catch(() => {});
    },

    getSettle() {
      this.settle = {
        totalAmount: "",
        paidAmount: "",
        unpaidAmount: ""
      };
      this.pricings = [];

      const loading = Loading.service({
        lock: true,
        text: "汇算中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      let baseURL = axios.defaults.baseURL.replace("/org", "");

      let data = {
        pricingTypes: this.pricingTypes,
        houseNameRegex: this.houseNameRegex,
        start: parseInt(new Date(this.daterange[0]).getTime() / 1000),
        paidStart: parseInt(new Date(this.daterangePaid[0]).getTime() / 1000),
        paidEnd: parseInt(new Date(this.daterangePaid[1]).getTime() / 1000),
        end: parseInt(new Date(this.daterange[1]).getTime() / 1000)
      };

      if (this.areaIDSelect.length > 0) {
        data.areaID = this.areaIDSelect[this.areaIDSelect.length - 1];
      }

      axios({
        method: "post",
        url: `${baseURL}settle`,
        data: data
      })
        .then(value => {
          this.settle = value.data.data;
          this.pricings = value.data.data.pricings;
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../style.css";
.item-title {
  text-align: start;
  font-size: 18px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.item-main {
  box-sizing: border-box;
  padding: 20px;
  margin-top: 10px;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.item-line {
  width: 100%;
  height: 1px;
  background: gray;
}
.box-card {
  width: 300px;
}
.item-main-plus {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.item {
  font-weight: bold;
  font-size: 25px;
}
</style>
